import React, { useState } from "react";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import useLoginStore from "../../store/useLoginStore";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useLoginStore();
  async function Loginfunction() {
    try {
      const config = {
        method: "POST",
        mode: "cors",
        url: `${API_BASE_URL}/userLogin`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          Email: email,
          Password: password,
        },
      };
      const response = await axios(config);
      console.log("res", response);
      if (response.status === 200) {
        toast.success("User created successfully");
        login();
      } else {
        toast.error("Something went wrong");
      }
    } catch (e) {
      console.log("Error:", e);
      toast.error(e.response?.data?.message || "An error occurred");
    }
  }
  return (
    <>
      <ToastContainer position="top-center" />
      <div className="flex flex-col items-center justify-center min-h-screen overflow-hidden">
        <div className="w-[40rem] p-20 m-auto bg-white rounded-md shadow-xl shadow-gray-200">
          <h1 className="text-3xl font-bold text-center text-[#1A2338] ">
            Login
          </h1>
          <div className="flex flex-col items-center justify-center mt-6">
            <div className="mb-2 w-[20rem]">
              <label
                for="email"
                className="block text-sm font-semibold text-gray-800"
              >
                Email
              </label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                className="block w-full px-4 py-2 mt-2 text-[#000] bg-white border rounded-md"
              />
            </div>
            <div className="mb-2 w-[20rem]">
              <label
                for="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Password
              </label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                className="block w-full px-4 py-2 mt-2 text-[#000] bg-white border rounded-md "
              />
            </div>

            <div onClick={Loginfunction} className="mt-6 w-[20rem]">
              <button className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-[#00C52C] rounded-md hover:bg-blue-700 focus:outline-none">
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
